import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'itemSetupCount',
})
export class ItemSetupCount implements PipeTransform {
  transform(itemsToSetUpList: any, valueChange): string {
    return itemsToSetUpList.filter((x) => x.status == 'created').length;
  }
}
